import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    advice: 'Mantente ocupada',
    reality: 'Sin estructura, la mente vuelve al mismo lugar.'
  }, {
    advice: 'Sal y socializa',
    reality: 'Cuando no tienes energía, eso es un castigo, no una solución.'
  }, {
    advice: 'Pon la tele',
    reality: 'Anestesia. No compañía.'
  }, {
    advice: 'Sé fuerte',
    reality: 'Eso solo te aísla más.'
  }, {
    advice: 'Medita',
    reality: 'Cuando la mente no coopera, el silencio es el enemigo.'
  }];
  return <section className="py-24 md:py-32 px-4 bg-[#151210]" data-id="element-24">
      <div className="max-w-4xl mx-auto" data-id="element-25">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-3xl md:text-4xl font-serif text-center text-[#f5efe6] mb-16" data-id="element-26">
          Ya intentaste todo lo que te dijeron.
        </motion.h2>

        <div className="grid gap-6" data-id="element-27">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.15
        }} className="flex flex-col md:flex-row items-start md:items-center gap-4 p-6 rounded-lg border border-[#d4a574]/10 bg-[#1a1714] hover:border-[#d4a574]/20 transition-colors duration-500" data-id="element-28">
              <div className="flex items-center gap-3 min-w-[200px]" data-id="element-29">
                <div className="p-2 rounded-full bg-red-900/20 text-red-400/80" data-id="element-30">
                  <X size={18} data-id="element-31" />
                </div>
                <span className="text-[#a8a29e] line-through decoration-red-400/50 decoration-2" data-id="element-32">
                  {item.advice}
                </span>
              </div>

              <div className="hidden md:block w-px h-8 bg-[#d4a574]/20 mx-2" data-id="element-33" />

              <p className="text-[#d4a574] font-medium italic" data-id="element-34">
                {item.reality}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}